define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		// Boolean: write only visible fields
		bWriteVisible: true,

		// Object: map of attributes to expressions indicating if should be hidden
		_hideExpressions: {
			BPMSG: "childAttr('Category.FilterType') != 'ProductType:Material'",
			BPSeason: "childAttr('Category.FilterType') != 'ProductType:Style'",
			BPCategory1: "!validValue('BPSeason')",
			BPCategory2: "!validValue('BPCategory1')",
			BPCollection: "!validValue('BPCategory2')"
		},

		getFormContext: function() {
			// summary: make sure Category is in cache for above expressions to work
			var	ctx = this.inherited(arguments);
			ctx.cache.getNode(ctx.getNode().Category, true);
			return ctx;			
		}
	});
});